// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__g09BU","header":"PatientQuestionnaire_header__1FsHb","info":"PatientQuestionnaire_info__e_Pqt"};